import React, { useEffect, useRef } from "react";
import CustomIconButton from "./CustomIconButton";

const CustomTextarea = ({
  scrollbarHidden = false,
  startIcon = null,
  maxLines,
  value,
  error,
  errorText,
  isResizable = true,
  size = "lg",
  customStyles = "",
  containerStyles = "",
  maxLength,
  tabindex = undefined,
  ...props
}: any) => {
  const styleBasedSizeProp: any = {
    lg: "py-3 px-3",
    md: "px-2 py-[0.375rem]",
  };

  const styleBasedErrorProp = !error
    ? "border alu-border active:border-[#FF861A] focus:border-[#FF861A]"
    : "border-2 border-[#F33D62] active:border-[#F33D62] focus:border-[#F33D62]";

  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  return (
    <div className={`relative ${containerStyles ? containerStyles : ""}`}>
      <textarea
        maxLength={maxLength}
        ref={textareaRef}
        value={value}
        tabIndex={tabindex}
        className={`custom-textinput ${styleBasedSizeProp[size]} ${
          scrollbarHidden ? "scrollbar-hide" : ""
        } ${
          props.disabled
            ? "bg-[#F7F7F7] !text-[#BBB] disabled:border-inherit"
            : "read-only:hover:bg-transparent hover:bg-[#FFF3E5] hover:border-transparent focus:hover:bg-[#FFF3E5] hover:border-transparent hover:bg-[#FFF3E5] bg-white active:text-[#343A3D] text-[#333]"
        } custom-scrollbar ${
          !isResizable ? "resize-none" : ""
        } w-full text-sm focus:outline-none focus:ring-0 leading-[1.3125rem] outline-0 ${styleBasedErrorProp} focus:hover:bg-[#FFF3E5] active:text-[#343A3D] text-[#333] rounded ${
          startIcon !== null ? "pl-[2.75rem]" : ""
        } ${customStyles}`}
        {...props}
      />
      {error && errorText && (
        <p className="alu-text-error text-sm">
          {errorText ? `*${errorText}` : "＊エラーテキストが入ります"}
        </p>
      )}
      {startIcon && (
        <CustomIconButton
          onClick={startIcon?.onClick}
          customStyle="absolute top-[0.375rem] left-2"
        >
          {startIcon?.icon}
        </CustomIconButton>
      )}
    </div>
  );
};

export default CustomTextarea;
